import {AA, BB, CC, DD, EE, FF, GG, HH, II, JJ, KK, LL, MM, NN, OO, PP, QQ, RR, SS, TT, UU, VV, WW, XX, YY, ZZ, N0, N1, N2, N3, N4, N5, N6, N7, N8, N9} from './alphabet.imba'

css .block
	ai: center

css .numbers
	d: grid
	gaf: column
	gac: 56px
	.symb
		bwr: 0
		&:last-child
			bwr: 1px

css .clear
	d: grid
	w: 100%
	max-width: 560px
	gtc: 1fr auto
	.symb
		w: auto
		&:last-child
			p: 0 24px
			bdl: 0

css .letters
	d: flex
	flw: wrap
	max-width: 560px
	bd: 1px solid rgba(255, 192, 0, 0.25)
	bwr: 0
	of: hidden
	.symb
		bwt: 0 bwl: 0
		mb: -1px
		&:last-child
			fl: 1

global css .symb
	cursor: pointer
	d: flex
	ai: center jc: center
	w: 55px h: 55px
	tween: 1s ease
	ff: 'Montserrat'
	fw: 600
	fs: 12px
	lh: 11px
	ta: center
	tt: uppercase
	ws: nowrap
	c: rgb(255, 236, 179)
	bd: 1px solid rgba(255, 192, 0, 0.25)
	svg
		display: block
		w: 16px h: 16px
		fill: rgb(255, 236, 179)
		tween: 1s ease
	&:hover
		bg: rgba(255, 192, 0, 0.1)
		tween: 0.2s ease
		svg
			fill: rgb(255, 192, 0)
			tween: 0.2s ease
css p
	fs: 12px
	ls: .5px
	span
		d: inline-block
		w: 1px
		h: 15px
		bg: rgb(255, 192, 0)
		w: 1px
		va: top
		ml: 1px
		animation: infinite flashing 1s ease

css @keyframes flashing
	0% o: 0
	75% o: 1
	100% o: 0

let cesar = 0

let arr-abc = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
let arr-num = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
let arr-sym = [' ', "'", '"', '.', ',', '?', '-', ':']

let phrase = []

let alphabet = [AA, BB, CC, DD, EE, FF, GG, HH, II, JJ, KK, LL, MM, NN, OO, PP, QQ, RR, SS, TT, UU, VV, WW, XX, YY, ZZ]
let numbers = [N0, N1, N2, N3, N4, N5, N6, N7, N8, N9]

export tag Decoder
	def render
		<self>
			<.block>
				<h3> 'Genopets Decoder'
				<p> phrase.length ? phrase.join('') : 'Select symbols to decipher'
					<span> if phrase.length
				<.numbers>
					for s, id in numbers
						<.symb @click=(do phrase.push(arr-num[id]))>
							<{s}>
				<.letters>
					for s, id in alphabet
						<.symb @click=(do phrase.push(arr-abc[id]))>
							<{s}>
					<.symb @click=(do phrase.push(arr-sym[0]))> 'Space'
				<.clear>
					<.symb @click=(do phrase.length=0)> 'Clear All'
					<.symb @click=(do phrase.pop())> 'Backspace'
				# <label> 'Caesar shift'
				# 	<.plus-minus>
				# 		<.mns-btn @click=cesar-->
				# 		<input type="number" inputmode="numeric" bind=cesar placeholder="Enter value">
				# 		<.pls-btn @click=cesar++>
				# <.symbols>